// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"4d9665a0","636":"453dfd02"}[chunkId] + ".chunk.css";
};